import clsx from 'clsx';
import React from 'react';

import { edit_profile_settings_path } from '@routes';

import styles from './styles.module.scss';

export default function UpdateProfileButton() {
  return (
    <div className={styles.updateProfileBtnWrapper}>
      <a href={edit_profile_settings_path()} className={clsx(styles.btn, styles.updateProfileBtn)}>
        Update Your Profile
      </a>
    </div>
  );
}
